@use "styles/abstracts/variables" as v;

.stuffing {
  display: flex;
  flex-direction: column;
  gap: 8px;

  .no-data {
    width: 100%;
    font-size: 30px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
  }
}

.loading {
  font-size: 20px;
  padding: 30px;
  text-align: center;
}

.Error {
  padding: 60px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: v.$palette-white;

  &__body {
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &-item {
      font-weight: 600;
      font-size: 20px;
      line-height: 30px;
      color: #000C37;

      b {
        margin-right: 10px;
      }

      & + & {
        margin-top: 16px;
      }

      span {
        display: inline-block;
        text-align: center;
      }
    }
  }
}
